import {
  StyledSwitchLabel,
  StyledSwitchInput,
  StyledSwitchDiv,
} from "./index.styled";
import { useTypedDispatch, useTypedSelector } from "@lib/redux";
import * as SettingsSlice from "@lib/redux/slices/settings";

const AppThemeSwitch = () => {
  const dispatch = useTypedDispatch();
  const { isDark } = useTypedSelector((state) => state.settings);
  const { height } = useTypedSelector((state) => state.screen.header);

  const onChange = () => {
    dispatch(SettingsSlice.toggleThemeMode(!isDark));
  };

  return (
    <StyledSwitchLabel height={height - 5}>
      <StyledSwitchInput type="checkbox" checked={isDark} onChange={onChange} />
      <StyledSwitchDiv />
    </StyledSwitchLabel>
  );
};

export default AppThemeSwitch;
